import { Box, Divider, Typography } from '@mui/material'
import React from 'react'
import SettingsMenuItem from './SettingsMenuItem'
import SettingsIcon from '@mui/icons-material/Settings';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import SecurityIcon from '@mui/icons-material/Security';
import GroupIcon from '@mui/icons-material/Group';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import KeyIcon from '@mui/icons-material/Key';

const SettingsMenu: React.FC = () => {
  return (
    <Box display={"flex"} flexDirection={"column"} width={"300px"} flexShrink={0} gap={"15px"}>
        <Box display={"flex"} gap={"10px"} alignItems={"center"}>
            <SettingsIcon style={{fontSize: "1.8em"}} />
            <Typography fontSize={"1.2em"} fontWeight={"bold"}>Settings</Typography>
        </Box>
        <Divider />
        <SettingsMenuItem icon={<AssignmentIndIcon />} title="Profile" />
        <SettingsMenuItem icon={<SecurityIcon />} title="Security" />
        <SettingsMenuItem icon={<GroupIcon />} title="Group" />
        <SettingsMenuItem icon={<LeaderboardIcon />} title="Statistics" />
        <SettingsMenuItem icon={<KeyIcon />} title="API keys" selected />
    </Box>
  )
}

export default SettingsMenu